<div matDialogTitle>{{ title }}</div>
<mat-dialog-content>{{ text }}</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton (click)="no()" i18n>{{ noCaption }}</button>
    <button matButton="filled" (click)="yes()" i18n>{{ yesCaption }}</button>
</mat-dialog-actions>
